import type { IconProps } from './types';

export const Unit = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="21" viewBox="0 0 25 21" fill="none" aria-hidden="true" {...props}>
    <g filter="url(#filter0_d_15916_4706)">
      <path
        d="M6.81273 5.96514c0-.15236 0-.73835 0-1.75796V2.4668h2.40739v8.6667c-.01172 1.1954.21682 2.1037.68561 2.7249.46877.6094 1.18787 1.5459 3.04227 1.5459 1.7248 0 2.642-.9365 3.1108-1.5459.4805-.6212.7149-1.5295.7031-2.7249V2.4668h2.3214v3.49834h2.9182v2.03923h-2.9182v1.6349h2.9182v2.03923h-2.9358c-.1172 1.9103-.6915 3.3636-1.7228 4.3597-1.0313.9962-2.4963 1.4943-4.3949 1.4943-1.8986 0-3.36355-.4981-4.39489-1.4943-1.03133-.9961-1.6056-2.4494-1.7228-4.3597H4V9.63927h2.81273v-1.6349H4V5.96514h2.81273Z"
        fill="var(--color-quanta-icon)"
      />
      <path
        d="M6.81273 2.37414h-.09265v3.49834H3.90735v2.22454h2.81273v1.4496H3.90735v2.22458H6.7435c.1301 1.8831.70823 3.332 1.74524 4.3337 1.05363 1.0177 2.54466 1.5203 4.45926 1.5203 1.9146 0 3.4057-.5026 4.4593-1.5203 1.037-1.0017 1.6151-2.4506 1.7452-4.3337h2.9417V9.54662h-2.9183v-1.4496h2.9183V5.87248h-2.9183V2.37414h-2.5066v8.76026c.0116 1.185-.2212 2.0693-.6838 2.6673l-.0002.0002c-.4599.5979-1.3531 1.5098-3.0373 1.5098-.9103 0-1.5357-.2295-1.9897-.5291-.4557-.3008-.7444-.6756-.97889-.9804-.45124-.5981-.67825-1.4827-.66663-2.6678V2.37414H6.81273Z"
        stroke="var(--color-quanta-icon)"
        strokeWidth="0.18531"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_15916_4706"
        x="0.851453"
        y="0.0575353"
        width="23.5598"
        height="20.6262"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="-0.370619" dy="0.370619" />
        <feGaussianBlur stdDeviation="1.29717" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15916_4706" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15916_4706" result="shape" />
      </filter>
    </defs>
  </svg>
);
